module.exports = __webpack_public_path__ + "img/empty2.12a38109.png";